import React from "react";
import { twMerge } from "tailwind-merge";
import type { IChatMessage } from "../../store/@types/chat";

type IChatBubble = {
  message: IChatMessage;
};

const ChatBubble: React.FC<IChatBubble> = ({ message }) => {
  const isAssistant = message.role === "assistant";

  return (
    <div
      className={twMerge(
        "max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed",
        isAssistant
          ? "mr-auto rounded-tl-sm bg-white text-black border border-gray-50/20"
          : "ml-auto rounded-tr-sm bg-primary-500 text-white",
      )}
    >
      {message.content}
    </div>
  );
};

export default ChatBubble;
